import { db, Segment } from 'technical/db';

export const segmentSyncService = {
  async download(segments: Segment[]): Promise<void> {
    await db.segments.bulkPut(segments);
  },

  async getByRingAndType(
    ringId: string,
    type: string,
  ): Promise<Segment | null> {
    const result = await db.segments
      .where('ringId')
      .equals(ringId)
      .filter((segment) => segment.segmentType === type)
      .toArray();

    if (!result || result.length <= 0) {
      return null;
    }

    return result[0];
  },

  async reset(): Promise<void> {
    await db.segments.clear();
  },
};
